import Settings from '../olr-common/Settings';

export default function ClassRoomService($http) {
  let url = Settings.backendEnv + "/api/v1/exam";

  this.getAllExamDetails = function(classId, subId){
    var req = {
      method: "GET",
      url:    url + "/" + classId + "/" + subId
    };

    return $http(req);
  };
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/ExamService.js
 **/